module.exports = __webpack_public_path__ + "img/uva.8161ec9c.png";